import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from '../user.service';

import { PAGES } from '../constants';
import { TranslateService } from 'ng2-translate/ng2-translate';

@Component({
  selector: 'cms-menu',
  templateUrl: './menu.component.html',
  styleUrls: [
    './menu.component.scss'
  ],
  providers: [ UserService ]
})
export class MenuComponent {

  pages: Array<any>;
  pageTitle: string[];

  user:any;
  constructor(private userService: UserService,
    private router: Router,
    private translator: TranslateService,
  ) {
    this.pageTitle = [];
    this.user = JSON.parse(userService.getUser());
    if ( this.user == null || this.user == undefined) {
      this.router.navigate(['/login']);
    }
    if (this.translator.currentLang === 'ptBR') {
      this.pages = [];
      PAGES.forEach((page) => {
        if (page.title !== 'paneltitle-usersapp') {
          this.pages.push(page);
        }
      });
    } else {
      this.pages = [];
      PAGES.forEach((page) => {
        if (page.title !== 'paneltitle-push') {
          this.pages.push(page);
        }
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/menu/menu.component.ts